
interface ProFeaturesProps {
  features: {
    title: string;
    description: string;
  }[];
}

export const ProFeatures = ({ features }: ProFeaturesProps) => {
  return (
    <div className="grid gap-8 md:grid-cols-3 mb-12">
      {features.map((feature, index) => (
        <div key={index} className="p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold text-primary mb-4">{feature.title}</h3>
          <p className="text-gray-600">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};
